import { render, staticRenderFns } from "./assessmentResult.vue?vue&type=template&id=50256913&scoped=true"
import script from "./assessmentResult.vue?vue&type=script&lang=js"
export * from "./assessmentResult.vue?vue&type=script&lang=js"
import style0 from "./assessmentResult.vue?vue&type=style&index=0&id=50256913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50256913",
  null
  
)

export default component.exports